import {assert} from 'Asserts';
import type {ProcedureRunReplicateEdgeInputREST} from 'procedures/network/ProcedureRunDAO';
import type {BaseCondition} from 'studies/typed/shared/procedure-runs/design-state/useExperimentDesignState';

import type {FlowchartEdgeSpec} from './ProcedureRunDesignFlowchartLayoutUtils';
import {parseProcedureRunDesignFlowchartNodeId} from './ProcedureRunDesignFlowchartNodeIdUtils';

interface BuildConditionReplicateFlowchartInputArgs {
  conditions: ReadonlyArray<BaseCondition>;
  edgeSpecs: Array<FlowchartEdgeSpec>;
}

function resolveEdgeEndpoint(
  nodeId: string,
  conditions: ReadonlyArray<BaseCondition>
): ProcedureRunReplicateEdgeInputREST['source'] {
  const {conditionIndex, replicateIndex, methodId} = parseProcedureRunDesignFlowchartNodeId(nodeId);
  const condition = conditions[conditionIndex];
  assert(condition != null, `Node ${nodeId} references missing condition index ${conditionIndex}`);
  return {
    templateMethodVersionId: methodId,
    conditionName: condition.name,
    replicateNumber: replicateIndex + 1,
  };
}

/**
 * Builds condition graph edge payload by resolving the rendered flowchart edges back to the backend
 * endpoint composite keys ({templateMethodVersionId, conditionName, replicateNumber}).
 */
export function buildConditionReplicateFlowchartInput({
  conditions,
  edgeSpecs,
}: BuildConditionReplicateFlowchartInputArgs): Array<ProcedureRunReplicateEdgeInputREST> {
  return edgeSpecs.map((edgeSpec) => ({
    source: resolveEdgeEndpoint(edgeSpec.sourceNodeId, conditions),
    target: resolveEdgeEndpoint(edgeSpec.targetNodeId, conditions),
  }));
}
